import TreeNode from "./TreeNode";

export default class GroupTreeNode extends TreeNode {
    constructor(group, id) {
        super(group, id);
    }

    getIdPrefix() {
        return "g";
    }

    getType() {
        return TreeNode.TYPE_GROUP
    }
}


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/GroupTreeNode.js